class Wizard {

    constructor(args) {

        let opts = {
            "wz_class": ".wizard",
            "wz_nav": ".wizard-nav",
            "wz_ori": ".horizontal",
            "wz_nav_style": "dots",
            "wz_content": ".wizard-content",
            "wz_buttons": ".wizard-buttons",
            "wz_button": ".wizard-btn",
            "wz_button_style": ".btn",
            "wz_step": ".wizard-step",
            "wz_form": ".wizard-form",
            "wz_next": ".next",
            "wz_prev": ".prev",
            "wz_finish": ".finish",

            "current_step": 0,
            "steps": 0,
            "navigation": "all",
            "buttons": true,
            "next": "Next",
            "prev": "Prev",
            "finish": "Submit",

            "i18n": {
                "empty_wz": "Not found any element to generate the Wizard with.",
                "empty_nav": "Nav does not exist or is empty.",
                "empty_content": "Content does not exist or is empty.",
                "diff_steps": "Discordance between the steps of nav and content.",
                "random": "There has been a problem, check the configuration and use of the wizard.",
                "title": "Step"
            }
        };

        this.prefabOpts(opts, args);

        this.wz_class = this.options.wz_class;
        this.wz_ori = this.options.wz_ori;
        this.wz_nav = this.options.wz_nav;
        this.wz_nav_style = this.options.wz_nav_style;
        this.wz_content = this.options.wz_content;
        this.wz_buttons = this.options.wz_buttons;
        this.wz_button = this.options.wz_button;
        this.wz_button_style = this.options.wz_button_style;
        this.wz_step = this.options.wz_step;
        this.wz_form = this.options.wz_form;
        this.wz_next = this.options.wz_next;
        this.wz_prev = this.options.wz_prev;
        this.wz_finish = this.options.wz_finish;

        this.steps = this.options.steps;
        this.current_step = this.options.current_step;
        this.last_step = this.current_step;
        this.navigation = this.options.navigation;
        this.buttons = this.options.buttons;
        this.prev = this.options.prev;
        this.next = this.options.next;
        this.finish = this.options.finish;
        this.form = false;
        this.locked = false;
        this.locked_step = null;
    }

    set_options(options) {
        this.options = options;
    }

    init() {
        try {
            let wz = ($_.exists($_.getSelector(this.wz_class))) ? $_.getSelector(this.wz_class) : $_.throwException(this.options.i18n.empty_wz);

            wz.classList.add((this.wz_ori).replace(".", ""));

            if (wz.tagName === "FORM") {
                this.form = true;
            }

            this.setNav();

            let wz_nav = ($_.exists($_.getSelector(this.wz_nav, wz))) ? $_.getSelector(this.wz_nav, wz) : $_.throwException(this.options.i18n.empty_nav);

            let wz_content = ($_.exists($_.getSelector(this.wz_content, wz))) ? $_.getSelector(this.wz_content, wz) : $_.throwException(this.options.i18n.empty_content);

            var wz_nav_steps = $_.getSelectorAll(this.wz_step, wz_nav);
            var wz_nav_steps_length = (wz_nav_steps.length > 0) ? wz_nav_steps.length : $_.throwException(this.options.i18n.empty_nav);;

            var wz_content_steps = $_.getSelectorAll(this.wz_step, wz_content);
            var wz_content_steps_length = (wz_content_steps.length > 0) ? wz_content_steps.length : $_.throwException(this.options.i18n.empty_content);

            if (wz_nav_steps_length != wz_content_steps_length) {
                $_.throwException(this.options.i18n.diff_steps);
            }

            switch (this.navigation) {
                case "nav":
                    this.buttons = false;
                    break;
            }

            this.steps = wz_nav_steps_length;

            this.set(wz_nav_steps, wz_content_steps)

            switch (this.navigation) {
                case "all":
                case "nav":
                    // this.setNavEvent()
                    this.setBtnEvent()

                    break;
                case "buttons":
                    this.setBtnEvent();
                    break;
            }

            wz.style.display = ($_.hasClass(wz, "vertical")) ? "flex" : "block";

            document.getElementById('WizardBackBtn').classList.add('hide');

        } catch (error) {
            throw error;
        }
    }

    set($wz_nav, $wz_content) {
        var active = false;
        var active_index = 0;

        for (let i = 0; i < $wz_nav.length; i++) {
            let $this = $wz_nav[i];

            active = (active === false) ? $_.hasClass($this, "active") : active;
            active_index = ($_.hasClass($this, "active")) ? i : active_index;

            $this.setAttribute("data-step", i);
            $wz_content[i].setAttribute("data-step", i);
        };

        $_.removeClassList($wz_nav, "active");
        $wz_nav[active_index].classList.add("active");

        $_.removeClassList($wz_content, "active");
        $wz_content[active_index].classList.add("active");

        $_.getSelector(this.wz_nav).classList.add(this.wz_nav_style);

        // if (this.form) {
        //     this.update2Form();
        // }

        this.setButtons();
    }

    reset() {
        this.setCurrentStep(0);

        let wz = $_.getSelector(this.wz_class);
        let nav = $_.getSelector(this.wz_nav, wz);
        let content = $_.getSelector(this.wz_content, wz);

        let buttons = $_.getSelector(this.wz_buttons, wz);
        let next = $_.getSelector(this.wz_button + this.wz_next, buttons);
        let prev = $_.getSelector(this.wz_button + this.wz_prev, buttons);
        let finish = $_.getSelector(this.wz_button + this.wz_finish, buttons);

        this.checkButtons(next, prev, finish)

        let $wz_nav = $_.getSelectorAll(this.wz_step, nav)
        $_.removeClassList($wz_nav, "active");

        let $wz_content = $_.getSelectorAll(this.wz_step, content)
        $_.removeClassList($wz_content, "active");

        $_.getSelector(`${this.wz_step}[data-step="${this.getCurrentStep()}"]`, nav).classList.add("active");
        $_.getSelector(`${this.wz_step}[data-step="${this.getCurrentStep()}"]`, content).classList.add("active");

        document.dispatchEvent(new Event("resetWizard"));
    }

    lock() {
        this.locked = true;
        this.locked_step = this.getCurrentStep();
    }

    unlock() {
        this.locked = false;
        this.locked_step = null;

        document.dispatchEvent(new Event("unlockWizard"));
    }

    update2Form() {
        let wz = $_.getSelector(this.wz_class);
        let wz_content = $_.getSelector(this.wz_content, wz);

        if (wz_content.tagName !== "FORM") {
            let wz_content_class = wz_content.getAttribute("class");
            let wz_content_content = wz_content.innerHTML

            wz_content.remove();
            var $form = document.createElement("form");

            $form.setAttribute("method", "POST");
            $form.setAttribute("class", wz_content_class + " " + (this.wz_form).replace(".", ""));

            $form.innerHTML = wz_content_content;

            wz.appendChild($form)
        }
    }

    checkForm() {
        let wz = $_.getSelector(this.wz_class);
        let wz_content = $_.getSelector(this.wz_content, wz);

        let steps = $_.getSelectorAll(this.wz_step, wz_content);
        let target = steps[this.getCurrentStep()];
        var validation = false;

        let inputs = $_.getSelectorAll("input,textarea,select", target);

        if (inputs.length > 0) {
            validation = $_.formValidator(inputs);
        } else {
            this.throwException(this.options.i18n.random);
        }

        return validation;
    }

    setNav() {
        let wz = $_.getSelector(this.wz_class);
        let wz_nav = $_.getSelector(this.wz_nav, wz);
        let wz_content = $_.getSelector(this.wz_content, wz);
        let steps = $_.getSelectorAll(this.wz_step, wz_content);

        if ($_.exists(wz_nav) === false) {
            var nav = document.createElement("ASIDE");
            nav.classList.add((this.wz_nav).replace(".", ""));

            var wz_content_steps = $_.getSelectorAll(this.wz_step, wz_content);
            var steps_length = wz_content_steps.length;

            for (var i = 0; i < steps_length; i++) {
                var nav_step = document.createElement("DIV");
                // let title = (steps[i].hasAttribute("data-title")) ? steps[i].getAttribute("data-title") : `${this.options.i18n.title} ${i}`;
                let title = (steps[i].hasAttribute("data-title")) ? steps[i].getAttribute("data-title") : '';
                nav_step.classList.add((this.wz_step).replace(".", ""));

                var dot = document.createElement("SPAN");
                dot.classList.add('dot');
                nav_step.appendChild(dot);

                var span = document.createElement("SPAN");
                span.innerHTML = title;
                nav_step.appendChild(span);

                nav.appendChild(nav_step);
            }

            wz.prepend(nav);
        }

        return true;
    }

    setButtons() {
        let wz = $_.getSelector(this.wz_class);
        let wz_btns = $_.getSelector(this.wz_buttons, wz);

        if ($_.exists(wz_btns) === false) {
            var buttons = document.createElement("ASIDE");
            buttons.classList.add((this.wz_buttons).replace(".", ""));

            var btn_style = (this.wz_button_style).replaceAll(".", "");
            btn_style = btn_style.split(" ");

            var prev = document.createElement("BUTTON");
            prev.innerHTML = this.prev;
            prev.classList.add((this.wz_button).replace(".", ""));
            prev.classList.add(...btn_style);
            prev.classList.add((this.wz_prev).replace(".", ""));

            if ($_.str2bool(this.buttons) === false) prev.style.display = "none";

            buttons.appendChild(prev);

            var next = document.createElement("BUTTON");
            next.innerHTML = this.next;
            next.classList.add((this.wz_button).replace(".", ""));
            next.classList.add(...btn_style);
            next.classList.add((this.wz_next).replace(".", ""));

            if ($_.str2bool(this.buttons) === false) next.style.display = "none";

            buttons.appendChild(next);

            var finish = document.createElement("BUTTON");
            finish.innerHTML = this.finish;
            finish.classList.add((this.wz_button).replace(".", ""));
            finish.classList.add(...btn_style);
            finish.classList.add((this.wz_finish).replace(".", ""));
            buttons.appendChild(finish);

            this.checkButtons(next, prev, finish)

            wz.appendChild(buttons);
        }

        return true;
    }

    checkButtons(next, prev, finish) {
        let current_step = this.getCurrentStep();
        let n_steps = this.steps - 1;

        if (current_step == 0) {
            if (prev) {
                prev.setAttribute("disabled", true);
            }
            document.getElementById('WizardBackBtn').classList.add('hide');
        } else {
            if (prev) {
                prev.removeAttribute("disabled");
            }
            document.getElementById('WizardBackBtn').classList.remove('hide');
        }

        if ($wizard_.orderVars.gift) {
            if (current_step > 3) {
                if ($wizard_.orderVars.box === 'korea' && current_step >= 7) {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step - 3);
                } else {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step - 2);
                }
            } else {
                if (current_step === 0) {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step + 1);
                } else {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step);
                }
            }
        } else {
            if (current_step > 3) {
                if ($wizard_.orderVars.box === 'korea' && current_step >= 7) {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step - 3);
                } else {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step - 2);
                }
            } else {
                if (current_step === 0) {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step + 1);
                } else {
                    document.getElementById('WizardStepCount').innerText = "Step " + (current_step);
                }
            }
        }

        if (current_step == n_steps) {
            if (next) {
                next.setAttribute("disabled", true);
            }
            if (finish) {
                finish.style.display = "block";
            }
        } else {
            if (finish) {
                finish.style.display = "none";
            }
            if (next) {
                next.removeAttribute("disabled");
            }
        }
    }

    onClick(e) {
        let $this = e

        if (this.locked && this.locked_step === this.getCurrentStep()) {
            document.dispatchEvent(new Event("lockWizard"));
            return false;
        }

        let parent = $_.getParent($this, this.wz_class);
        let nav = $_.getSelector(this.wz_nav, parent);
        let content = $_.getSelector(this.wz_content, parent);

        var is_btn = ($_.hasClass($this, this.wz_button));

        let step = ($_.str2bool($this.getAttribute("data-step")) !== false) ? parseInt($this.getAttribute("data-step")) : this.getCurrentStep();

        if (is_btn) {
            try {
                var selectBoxType = $wizard_.orderVars.gift ? 'gift' : 'self';
                if (this.getCurrentStep() === 0 && $wizard_.analytics.boxType.indexOf(selectBoxType) < 0 && tapCartWizardStep === 0) {
                    dataLayer.push({ 'event': 'selectBoxType', 'label': selectBoxType });
                    $wizard_.analytics.boxType.push(selectBoxType);
                }

                if (this.getCurrentStep() === (1 - tapCartWizardStep) && $wizard_.analytics.box.indexOf($wizard_.orderVars.box) < 0) {
                    dataLayer.push({ 'event': 'selectBox', 'label': $wizard_.orderVars.box });
                    $wizard_.analytics.box.push($wizard_.orderVars.box);
                }

                if ((this.getCurrentStep() === (3 - tapCartWizardStep) || this.getCurrentStep() === (4 - tapCartWizardStep)) && $wizard_.analytics.plan.indexOf($wizard_.orderVars.plan) < 0) {
                    dataLayer.push({ 'event': 'selectPlan', 'label': $wizard_.orderVars.plan + ' Month' });
                    $wizard_.analytics.plan.push($wizard_.orderVars.plan);
                }

                if ((this.getCurrentStep() === (2 - tapCartWizardStep) || this.getCurrentStep() === (5 - tapCartWizardStep)) && $wizard_.analytics.size.indexOf($wizard_.orderVars.size) < 0) {
                    dataLayer.push({ 'event': 'selectSize', 'label': $wizard_.orderVars.size });
                    $wizard_.analytics.size.push($wizard_.orderVars.size);
                }

                if (this.getCurrentStep() === (6 - tapCartWizardStep) && !$wizard_.analytics.drink && $wizard_.orderVars.drink) {
                    dataLayer.push({ 'event': 'selectDrink', 'label': 'Drink Added' });
                    $wizard_.analytics.drink = true;
                }

                if (this.getCurrentStep() === (7 - tapCartWizardStep) && !$wizard_.analytics.pp && $wizard_.orderVars.pp) {
                    dataLayer.push({ 'event': 'selectPriorityProcessing', 'label': 'Priority Processing Added' });
                    $wizard_.analytics.pp = true;
                }
            } catch (e) {
                console.log(e);
            }

            var adjustedStep = false;
            if ($_.hasClass($this, this.wz_prev)) {
                if (tapCartWizard) {
                    if (step === 4) {
                        step -= 2;
                    }
                    
                } else {
                    console.log("step: " + step);
                    if (!$wizard_.orderVars.gift && step === 2) {
                        step -= 2;
                        adjustedStep = true;
                    } else {
                        if ($wizard_.orderVars.gift && step === 4) {
                            step -= 4;
                            adjustedStep = true;
                        }
                    }
                    if (!$wizard_.orderVars.gift && step === 6) {
                        step -= 3;
                        adjustedStep = true;
                    } else {
                        if ($wizard_.orderVars.gift && step === 4) {
                            step -= 3;
                            adjustedStep = true;
                        }
                    }
                    if ($wizard_.orderVars.box === 'korea' && step === 7) {
                        if (!$wizard_.orderVars.gift) {
                            step -= 4;
                            adjustedStep = true;
                        } else {
                            step = step - 2;
                            adjustedStep = true;
                        }
                    }

                    if ($wizard_.orderVars.plan === 1 && step === 7 && $wizard_.orderVars.gift) {
                        step -= 2;
                        adjustedStep = true;
                    }
                    if ($wizard_.orderVars.plan === 1 && step === 7 && !$wizard_.orderVars.gift) {
                        step -= 4;
                        adjustedStep = true;
                    }
                }
                if (!adjustedStep) {
                    step--;
                }
                document.dispatchEvent(new Event("prevWizard"));
            } else if ($_.hasClass($this, this.wz_next)) {
                console.log("step: " + step);
                if (tapCartWizard) {
                    if (step === 1) {
                        step += 2;
                    }
                } else {
                    if ($wizard_.orderVars.gift && step === 0) {
                        if (tapCartWizard) {
                            step += 2;
                        } else {
                            step += 4;
                        }
                        adjustedStep = true;
                    } else {
                        if (!$wizard_.orderVars.gift && step === 0) {
                            step += 2;
                            adjustedStep = true;
                        }
                    }
                    if ($wizard_.orderVars.gift && step === 1) {
                        step += 3;
                        adjustedStep = true;
                    } else {
                        if (!$wizard_.orderVars.gift && step === 3) {
                            if ($wizard_.orderVars.plan === 1) {
                                step += 4;
                            } else {
                                step += 3;
                            }
                            
                            adjustedStep = true;
                        }
                    }
                    if ($wizard_.orderVars.box === 'korea' && step === 5) {
                        step = step + 2;
                        adjustedStep = true;
                    } else {
                        if ($wizard_.orderVars.box === 'korea' && step === 6) {
                            step = step + 1;
                            adjustedStep = true;
                        }
                    }
                    if ($wizard_.orderVars.plan === 1 && (step === 5 && $wizard_.orderVars.gift)) {
                        step = step + 2;
                        adjustedStep = true;
                    }
                }
                

                if (!adjustedStep) {
                    step++;
                }
                document.dispatchEvent(new Event("nextWizard"));
            }
            window.scrollTo(0, 0);
        }

        if (this.form && this.navigation != "buttons") {
            if (step > this.getCurrentStep()) {
                if ((step !== this.getCurrentStep() + 1)) {
                    if (step >= this.last_step) {
                        step = this.last_step;
                    } else {
                        step = this.getCurrentStep() + 1;
                    }
                }
            }
        }

        if (this.form) {
            if (this.checkForm() === true) {
                this.last_step = this.getCurrentStep();
                if (this.getCurrentStep() < step) {
                    return false;
                }
            }
        }

        if ($_.str2bool(step)) {
            this.setCurrentStep(step)
        }

        let buttons = $_.getSelector(this.wz_buttons, parent);
        let next = $_.getSelector(this.wz_button + this.wz_next, buttons);
        let prev = $_.getSelector(this.wz_button + this.wz_prev, buttons);
        let finish = $_.getSelector(this.wz_button + this.wz_finish, buttons);

        this.checkButtons(next, prev, finish)

        let $wz_nav = $_.getSelectorAll(this.wz_step, nav)
        $_.removeClassList($wz_nav, "active");

        let $wz_content = $_.getSelectorAll(this.wz_step, content)
        $_.removeClassList($wz_content, "active");

        $_.getSelector(`${this.wz_step}[data-step="${this.getCurrentStep()}"]`, nav).classList.add("active");
        $_.getSelector(`${this.wz_step}[data-step="${this.getCurrentStep()}"]`, content).classList.add("active");
    }

    onClickFinish(e) {
        if (this.form) {
            if (this.checkForm() !== true) {
                document.dispatchEvent(new Event("submitWizard"));
            }
        } else {

            document.dispatchEvent(new Event("endWizard"));
        }
    }

    setCurrentStep(step) {
        this.current_step = this.setStep(step);
    }

    getCurrentStep() {
        return this.current_step;
    }

    setStep(step) {
        let parent = $_.getSelector(this.wz_class);
        let content = $_.getSelector(this.wz_content, parent);

        let check_content = $_.getSelector(`${this.wz_step}[data-step="${step}"]`, content);

        if ($_.exists(check_content) === false) {
            let content_length = ($_.getSelectorAll(this.wz_step, content).length) - 1;

            let diff = this.closetNubmer(content_length, step)

            step = diff;
        }

        this.last_step = (step > this.last_step) ? step : this.last_step;

        return parseInt(step);
    }

    closetNubmer(length, step) {
        var counts = [];

        for (let index = 0; index <= length; index++) {
            counts.push(index)
        }

        let closet = counts.reduce(function (prev, curr) {
            return (Math.abs(curr - step) < Math.abs(prev - step) ? curr : prev);
        });

        return closet;
    }

    setNavEvent() {
        let _self = this;

        $_.delegate(document, "click", this.wz_nav + " " + this.wz_step, function (event) {
            event.preventDefault()
            _self.onClick(this)
        });
    }

    setBtnEvent() {
        let _self = this;

        $_.delegate(document, "click", this.wz_buttons + " " + this.wz_button, function (event) {
            event.preventDefault()

            if ($_.hasClass(event.target, _self.wz_finish)) {
                _self.onClickFinish(this)
            } else {
                _self.onClick(this)

            }
        });
    }

    prefabOpts(options, args) {
        Object.entries(args).forEach(([key, value]) => {
            if (typeof value === 'object') {
                Object.entries(value).forEach(([key_1, value_1]) => {
                    options[key][key_1] = value_1;
                });
            } else {
                options[key] = value;
            }
        });

        this.set_options(options);
    }
};


// Helper Functions
var $_ = {

    getID: function (e, n = document) {
        return n.getElementById(e);
    },

    getClass: function (e, n = document) {
        return n.getElementsByClassName(e);
    },

    getTag: function (e, n = document) {
        return n.getElementsByTagName(e);
    },

    getSelector: function (e, n = document) {
        return n.querySelector(e);
    },

    getSelectorAll: function (e, n = document) {
        return n.querySelectorAll(e);
    },

    hasClass: function (e, className) {
        className = className.replace(".", "");
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(e.className);
    },

    getParent: function (elem, selector) {
        var parent = undefined;

        while (elem.parentNode.tagName !== "BODY" && parent === undefined) {
            elem = elem.parentNode;

            if (elem.matches(selector)) {
                parent = elem;
            }
        }

        return parent;
    },

    delegate: function (el, evt, sel, handler) {
        el.addEventListener(evt, function (event) {
            var t = event.target;
            while (t && t !== this) {
                if (t.matches(sel)) {
                    handler.call(t, event);
                }
                t = t.parentNode;
            }
        });
    },

    removeClassList: function (e, className) {
        for (let element of e) {
            element.classList.remove(className);
        };
    },

    objToString: function (obj, delimiter = ";") {
        var str = '';
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str += p + ':' + obj[p] + delimiter;
            }
        }
        return str;
    },

    isHidden: function (el) {
        var style = window.getComputedStyle(el);
        return (style.display === 'none')
    },

    str2bool: function (str) {
        str = String(str);
        switch (str.toLowerCase()) {
            case 'false':
            case 'no':
            case 'n':
            case '':
            case 'null':
            case 'undefined':
                return false;
            default:
                return true;
        }
    },

    exists: function (element) {
        return (typeof (element) != 'undefined' && element != null);
    },

    throwException: function (message) {
        var err;
        try {
            throw new Error('myError');
        } catch (e) {
            err = e;
        }
        if (!err) return;

        var aux = err.stack.split("\n");
        aux.splice(0, 2); //removing the line that we force to generate the error (var err = new Error();) from the message
        aux = aux.join('\n"');
        throw message + ' \n' + aux;
    },

    formValidator: function (formData) {
        var error = false;
        for (let e of formData) {
            if ($_.hasClass(e, "required") || $_.exists(e.getAttribute("required"))) {

                var check = false
                switch (e.tagName) {
                    case "INPUT":
                        check = $_.dispatchInput(e);
                        break;
                    case "SELECT":
                    case "TEXTAREA":
                        check = $_.isEmpty(e.value);
                        break;
                }

                if (check === false) {
                    error = true;
                    $_.highlight(e, "error");
                }
            }
        }

        return error;
    },

    highlight: function (e, highlight = "error") {
        let classHigh = "highlight-" + highlight

        e.classList.add(classHigh)
        setTimeout(function () {
            document.querySelectorAll('[class*="highlight"]')
                .forEach((el) => {
                    for (let i = el.classList.length - 1; i >= 0; i--) {
                        let className = el.classList[i];
                        if (className.startsWith('highlight')) {
                            el.classList.remove(className);
                        }
                    }
                });
        }, 1000);

    },

    dispatchInput: function (e) {
        let type = e.getAttribute("type");
        var check = false;

        switch (type) {
            case "email":
                check = $_.isEmail(e.value);
                break;
            case "url":
                check = $_.isValidURL(e.value);
                break;
            case "checkbox":
            case "radio":
                check = e.checked;
                break;
            default:
                check = $_.isEmpty(e.value);
                break;
        }

        return check
    },

    isEmpty: function (val) {
        return (val != undefined && val != null && val.length > 0);
    },

    isEmail: function (email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    },

    isValidURL: function (str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

        return !!pattern.test(str);
    }
}

var $wizard_ = {
    orderVars: {
        gift: false,
        box: 'munch',
        size: 'standard',
        plan: 1,
        drink: false,
        pp: false,
        addons: [],
        boxData: munchBoxItems,
        baseBoxPrice: 0,
        adding: false,
        freeGift: 42475833163932
    },
    analytics: {
        boxType: [],
        box: [],
        plan: [],
        size: [],
        drink: false,
        pp: false,
        addons: []
    },
    upsellVars: {
        page: 1,
        sortBy: '',
        loading: false
    },
    radioBtnClick: function (targetElement) {
        var parentElm = targetElement.parentElement;
        switch (parentElm.id) {
            case 'Select_BoxType':
                this.orderVars.gift = $_.str2bool(targetElement.getAttribute('data-value'));
                this.refresh('gift');
                break;
            case 'Select_BoxKind':
                this.orderVars.box = targetElement.getAttribute('data-value');
                this.refresh('box');
                break;
            case 'Select_BoxSize_Gift':
            case 'Select_BoxSize':
                this.orderVars.size = targetElement.getAttribute('data-value');
                this.refresh('size');
                break;
            case 'Select_Plan_Gift':
            case 'Select_Plan':
                this.orderVars.plan = parseInt(targetElement.getAttribute('data-value'));
                this.refresh('plan');
                break;
            case 'Select_FreeBox':
                this.orderVars.freeGift = parseInt(targetElement.getAttribute('data-value'));
                breakl;
        }
        // console.log(this.orderVars);
    },
    primaryBtnClick: function (targetElement) {
        var dataSet = targetElement.getAttribute('data-set');
        switch (dataSet) {
            case 'box':
                this.orderVars.box = targetElement.getAttribute('data-value');
                this.refresh('box');
                break;
            case 'drink':
                this.orderVars.drink = $_.str2bool(targetElement.getAttribute('data-value'));
                break;
            case 'pp':
                this.orderVars.pp = $_.str2bool(targetElement.getAttribute('data-value'));
                break;
        }
        // console.log(this.orderVars);
    },
    refresh: function (refreshFrom) {
        //Set boxData
        switch (this.orderVars.box) {
            case 'munch':
                this.orderVars.boxData = this.orderVars.gift ? munchGiftBoxItems : munchBoxItems;
                break;
            case 'korea':
                this.orderVars.boxData = this.orderVars.gift ? koreaGiftBoxItems : koreaBoxItems;
                break;
        }

        var giftTexts = document.getElementsByClassName("box-type-text-gift");
        for (var i = 0; i < giftTexts.length; i++) {
            if (this.orderVars.gift) {
                giftTexts[i].classList.remove('hide');
            } else {
                giftTexts[i].classList.add('hide');
            }
        }
        var selfTexts = document.getElementsByClassName("box-type-text-self");
        for (var i = 0; i < selfTexts.length; i++) {
            if (!this.orderVars.gift) {
                selfTexts[i].classList.remove('hide');
            } else {
                selfTexts[i].classList.add('hide');
            }
        }

        //Set order variables
        if (this.orderVars.gift) {
            switch (refreshFrom) {
                case 'gift':
                    this.orderVars.box = 'munch';
                    this.orderVars.boxData = munchGiftBoxItems;
                case 'box':
                    this.orderVars.plan = 1;
                case 'plan':
                    switch (this.orderVars.plan) {
                        case 1:
                            this.orderVars.size = this.orderVars.boxData.standard.monthly ? 'standard' : this.orderVars.boxData.premium.monthly ? 'premium' : this.orderVars.boxData.deluxe.monthly ? 'deluxe' : 'motherload';
                            break;
                        default:
                            this.orderVars.size = this.orderVars.boxData.standard.prepay[this.orderVars.plan] ? 'standard' : this.orderVars.boxData.premium.prepay[this.orderVars.plan] ? 'premium' : this.orderVars.boxData.deluxe.prepay[this.orderVars.plan] ? 'deluxe' : 'motherload';
                            break;
                    }
                case 'size':
                    if (this.orderVars.box === 'munch') {
                        this.orderVars.baseBoxPrice = munchBoxItems[this.orderVars.size].monthly.variants.regular.price;
                    } else {
                        this.orderVars.baseBoxPrice = koreaBoxItems[this.orderVars.size].monthly.variants.regular.price;
                    }
                    this.orderVars.drink = false;
                    break;
            }
        } else {
            switch (refreshFrom) {
                case 'gift':
                    this.orderVars.box = 'munch';
                    this.orderVars.boxData = munchBoxItems;
                case 'box':
                    this.orderVars.size = 'standard';
                case 'size':
                    if (this.orderVars.box === 'munch') {
                        this.orderVars.baseBoxPrice = munchBoxItems[this.orderVars.size].monthly.variants.regular.price;
                    } else {
                        this.orderVars.baseBoxPrice = koreaBoxItems[this.orderVars.size].monthly.variants.regular.price;
                    }
                    var plans = this.orderVars.boxData[this.orderVars.size];
                    this.orderVars.plan = plans.monthly ? 1 : plans.prepay["3"] ? 3 : 6;
                case 'plan':
                    this.orderVars.drink = false;
                    break;
            }
        }

        //Select Box Kind
        var boxKindElm = document.getElementById('Select_BoxKind');
        if (boxKindElm) {
            boxKindElm.getElementsByTagName('li')[0].classList.remove('selected');
            boxKindElm.getElementsByTagName('li')[1].classList.remove('selected');
            if (this.orderVars.box === 'munch') {
                boxKindElm.getElementsByTagName('li')[0].classList.add('selected');
            } else {
                boxKindElm.getElementsByTagName('li')[1].classList.add('selected');
            }
        }


        //Populate Box Sizes
        var boxSizeElm = document.getElementById('Select_BoxSize');
        var boxSizeConfirmation = document.getElementById('BoxSizeConfirmation');
        var motherloadConfirmation = document.getElementById('MotherloadConfirmation');
        var boxSizeElm_Gift = document.getElementById('Select_BoxSize_Gift');
        var boxSizeConfirmation_Gift = document.getElementById('BoxSizeConfirmation_Gift');
        var motherloadConfirmation_Gift = document.getElementById('MotherloadConfirmation_Gift');
        var munchStandardBoxImg = document.getElementById('Munch_Standard_Img').value;
        var munchPremiumBoxImg = document.getElementById('Munch_Premium_Img').value;
        var munchDeluxeBoxImg = document.getElementById('Munch_Deluxe_Img').value;
        var munchMotherloadBoxImg = document.getElementById('Munch_Motherload_Img').value;
        var koreaStandardBoxImg = document.getElementById('Korea_Standard_Img').value;
        var koreaPremiumBoxImg = document.getElementById('Korea_Premium_Img').value;
        boxSizeElm.innerHTML = '';
        boxSizeElm_Gift.innerHTML = '';

        for (key in this.orderVars.boxData) {
            var li = document.createElement("li");
            li.setAttribute('data-value', key);
            li.classList.add('grid__item');
            if (key === this.orderVars.size) {
                li.classList.add('selected');
            }
            var boxPrice = "";

            if (this.orderVars.gift) {
                if (this.orderVars.boxData[key].monthly) {
                    boxPrice = this.orderVars.boxData[key].monthly.variants['regular'].price.toFixed(2);
                } else {
                    boxPrice = this.orderVars.boxData[key].prepay[Object.keys(this.orderVars.boxData[key].prepay)[0]].variants['regular'].price.toFixed(2);
                }
            } else {
                var finalIndex = Object.keys(this.orderVars.boxData[key].prepay).length - 1;
                var prepaidPrice = this.orderVars.boxData[key].prepay[Object.keys(this.orderVars.boxData[key].prepay)[finalIndex]].variants['regular'].price;
                boxPrice = (prepaidPrice / 12).toFixed(2);
            }
            var koreaDrinkText = this.orderVars.box === 'korea' && key === 'premium' ? ' + 1 Drink' : '';
            var boxImage = '';
            switch (key) {
                case 'standard':
                    boxImage = this.orderVars.box === 'korea' ? koreaStandardBoxImg : munchStandardBoxImg;
                    break;
                case 'premium':
                    boxImage = this.orderVars.box === 'korea' ? koreaPremiumBoxImg : munchPremiumBoxImg;
                    break;
                case 'deluxe':
                    boxImage = munchDeluxeBoxImg;
                    break;
                case 'motherload':
                    boxImage = munchMotherloadBoxImg;
                    break;
            }
            //li.innerHTML = '<span class="button-left">' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</span><span class="button-right">as low as<br />$' + boxPrice + '</span>';
            li.innerHTML = '<div class="grid-button"><div class="grid-button-header"><h4>' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</h4></div><img srcset="' + boxImage + ' 4x,' + boxImage + ' 3x, ' + boxImage + ' 2x, ' + boxImage + '" src="' + boxImage + '" alt="Munch Box Size"><p class="box-description"><span class="box-title">' + key + ' Box</span><span class="box-price">as low as <br> <span>' + currencySymbol + boxPrice + '<span>/box</span></span></span></p></div>';
            boxSizeElm.appendChild(li);
        };

        if (this.orderVars.size === 'motherload') {
            boxSizeConfirmation.classList.add('hide');
            motherloadConfirmation.classList.remove('hide');
            boxSizeConfirmation_Gift.classList.add('hide');
            motherloadConfirmation_Gift.classList.remove('hide');
        } else {
            boxSizeConfirmation.classList.remove('hide');
            motherloadConfirmation.classList.add('hide');
            boxSizeConfirmation_Gift.classList.remove('hide');
            motherloadConfirmation_Gift.classList.add('hide');
        }

        var firstInit = false;
        for (key in this.orderVars.boxData) {
            var append = false;
            var li = document.createElement("li");
            li.classList.add('grid__item');
            li.setAttribute('data-value', key);
            if (key === this.orderVars.size) {
                li.classList.add('selected');
            }

            var boxPrice = "";
            var boxPrice2 = "";
            switch (this.orderVars.plan) {
                case 1:
                    append = key !== 'standard' && ((this.orderVars.box === 'munch' && key !== 'premium') || (this.orderVars.box === 'korea' && key !== 'standard'));
                    break;
                case 3:
                    append = (this.orderVars.box === 'munch' && key !== 'standard') || this.orderVars.box === 'korea';
                    break;
                case 6:
                    append = true;
                    break;
                case 12:
                    append = true;
                    break;
            }

            if (this.orderVars.boxData[key].monthly && append) {
                boxPrice = this.orderVars.boxData[key].monthly.variants['regular'].price.toFixed(2);
            }
            if (this.orderVars.boxData[key].prepay[this.orderVars.plan] && append) {
                boxPrice2 = (this.orderVars.boxData[key].prepay[this.orderVars.plan].variants['regular'].price / this.orderVars.plan).toFixed(2)
            }



            if (append) {
                var boxImage = '';
                switch (key) {
                    case 'standard':
                        boxImage = this.orderVars.box === 'korea' ? koreaStandardBoxImg : munchStandardBoxImg;
                        break;
                    case 'premium':
                        boxImage = this.orderVars.box === 'korea' ? koreaPremiumBoxImg : munchPremiumBoxImg;
                        break;
                    case 'deluxe':
                        boxImage = munchDeluxeBoxImg;
                        break;
                    case 'motherload':
                        boxImage = munchMotherloadBoxImg;
                        break;
                }
                //li.innerHTML = '<span class="button-left">' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</span><span class="button-right">as low as<br />$' + boxPrice + '</span>';
                var koreaDrinkText = this.orderVars.box === 'korea' && key === 'premium' ? ' + 1 Drink' : '';
                if (!firstInit && this.orderVars.plan === 1) {
                    //li.innerHTML = '<span class="button-left">' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</span><span class="button-right">$' + boxPrice + '<br />per delivery</span>';
                    li.innerHTML = '<div class="grid-button"><div class="grid-button-header"><h4>' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</h4></div><img srcset="' + boxImage + ' 4x,' + boxImage + ' 3x, ' + boxImage + ' 2x, ' + boxImage + '" src="' + boxImage + '" alt="Munch Box Size"><p class="box-description"><span class="box-title">' + key + ' Box</span><span class="box-price">as low as <br> <span>' + currencySymbol + boxPrice + '<span>/box</span></span></span></p></div>';
                    firstInit = true;
                } else {
                    if (this.orderVars.plan === 1 && key === 'motherload') {
                        //li.innerHTML = '<span class="button-left">' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</span><span class="button-right">$' + boxPrice + '<br />per delivery</span>';
                        li.innerHTML = '<div class="grid-button"><div class="grid-button-header"><h4>' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</h4></div><img srcset="' + boxImage + ' 4x,' + boxImage + ' 3x, ' + boxImage + ' 2x, ' + boxImage + '" src="' + boxImage + '" alt="Munch Box Size"><p class="box-description"><span class="box-title">' + key + ' Box</span><span class="box-price">as low as <br> <span>' + currencySymbol + boxPrice + '<span>/box</span></span></span></p></div>';
                    } else {
                        //li.innerHTML = '<span class="button-left">' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</span><span class="button-right">$' + boxPrice2 + '<br />per delivery</span>';
                        li.innerHTML = '<div class="grid-button"><div class="grid-button-header"><h4>' + this.orderVars.boxData[key].snacks + ' Snacks' + koreaDrinkText + '</h4></div><img srcset="' + boxImage + ' 4x,' + boxImage + ' 3x, ' + boxImage + ' 2x, ' + boxImage + '" src="' + boxImage + '" alt="Munch Box Size"><p class="box-description"><span class="box-title">' + key + ' Box</span><span class="box-price">as low as <br> <span>' + currencySymbol + boxPrice2 + '<span>/box</span></span></span></p></div>';
                    }
                }
                boxSizeElm_Gift.appendChild(li);
            }
        };


        //Populate Plans
        var oneMonth = document.getElementById('Plan_OneMonth');
        var threeMonth = document.getElementById('Plan_ThreeMonth');
        var sixMonth = document.getElementById('Plan_SixMonth');
        var twelveMonth = document.getElementById('Plan_TwelveMonth');
        var billingTotalPrice = document.getElementById('Billing_TotalPrice');
        var billingSavings = document.getElementById('Billing_Savings');
        var billingSavingsPrice = document.getElementById('Billing_SavingsPrice');
        var billingInterval = document.getElementById('Billing_Interval');
        var oneMonthGift = document.querySelector('#Gift_Plan_OneMonth');
        var threeMonthGift = document.querySelector('#Gift_Plan_ThreeMonth');
        var sixMonthGift = document.querySelector('#Gift_Plan_SixMonth');
        var twelveMonthGift = document.querySelector('#Gift_Plan_TwelveMonth');
        var oneMonthGiftPrice = document.getElementById('Gift_OneMonth_Price');
        var threeMonthGiftPrice = document.getElementById('Gift_ThreeMonth_Price');
        var sixMonthGiftPrice = document.getElementById('Gift_SixMonth_Price');
        var twelveMonthGiftPrice = document.getElementById('Gift_TwelveMonth_Price');
        var billingTotalPriceGift = document.getElementById('Billing_TotalPrice_Gift');
        var billingSavingsGift = document.getElementById('Billing_Savings_Gift');
        var billingSavingsPriceGift = document.getElementById('Billing_SavingsPrice_Gift');
        var billingIntervalGift = document.getElementById('Billing_Interval_Gift');
        var plans = this.orderVars.boxData[this.orderVars.size];
        var totalPrice = 0;
        var savings = 0;
        var interval = '';
        var gift_interval = '';
        var extra_gift_text = ' First box ships immediately.'

        oneMonth.classList.remove('selected', 'hide', 'disabled');
        threeMonth.classList.remove('selected', 'hide', 'disabled');
        sixMonth.classList.remove('selected', 'hide', 'disabled');
        twelveMonth.classList.remove('selected', 'hide', 'disabled');
        oneMonthGift.classList.remove('selected', 'hide', 'disabled');
        threeMonthGift.classList.remove('selected', 'hide', 'disabled');
        sixMonthGift.classList.remove('selected', 'hide', 'disabled');
        twelveMonthGift.classList.remove('selected', 'hide', 'disabled');

        switch (this.orderVars.plan) {
            case 1:
                oneMonth.classList.add('selected');
                oneMonthGift.classList.add('selected');
                interval = 'monthly';
                gift_interval = 'Ships immediately.';
                break;
            case 3:
                threeMonth.classList.add('selected');
                threeMonthGift.classList.add('selected');
                interval = 'every 3 months';
                gift_interval = 'One box a month for 3 months.' + extra_gift_text;
                break;
            case 6:
                sixMonth.classList.add('selected');
                sixMonthGift.classList.add('selected');
                interval = 'every 6 months';
                gift_interval = 'One box a month for 6 months.' + extra_gift_text;
                break;
            case 12:
                twelveMonth.classList.add('selected');
                twelveMonthGift.classList.add('selected');
                interval = 'every year';
                gift_interval = 'One box a month for a year.' + extra_gift_text;
                break;
        }

        if (this.orderVars.plan === 1) {
            if (plans.monthly) {
                totalPrice = plans.monthly.variants.regular.price.toFixed(2);
            } else {
                totalPrice = plans.prepay[this.orderVars.plan].variants.regular.price.toFixed(2);
            }
        } else {
            totalPrice = plans.prepay[this.orderVars.plan].variants.regular.price.toFixed(2);
        }
        savings = ((this.orderVars.baseBoxPrice * this.orderVars.plan - totalPrice) + (this.orderVars.gift ? 5 : 0)).toFixed(2);
        if (savings <= 0) {
            billingSavings.classList.add('hide');
            billingSavingsGift.classList.add('hide');
        } else {
            billingSavings.classList.remove('hide');
            billingSavingsGift.classList.remove('hide');
        }
        billingTotalPrice.innerHTML = currencySymbol + totalPrice;
        billingSavingsPrice.innerHTML = currencySymbol + savings;
        billingInterval.innerHTML = interval;
        billingTotalPriceGift.innerHTML = currencySymbol + totalPrice;
        billingSavingsPriceGift.innerHTML = currencySymbol + savings;
        billingIntervalGift.innerHTML = gift_interval;


        if (plans.monthly) {
            oneMonth.classList.remove('hide');
            oneMonth.getElementsByClassName('price')[0].innerHTML = currencySymbol + plans.monthly.variants.regular.price.toFixed(2);
            if (this.orderVars.gift) {
                oneMonth.getElementsByClassName('interval')[0].innerHTML = '1 Month';
            } else {
                oneMonth.getElementsByClassName('interval')[0].innerHTML = 'Monthly';
            }
        } else {
            if (plans.prepay && plans.prepay["3"]) {
                oneMonth.classList.add('disabled');
            } else {
                oneMonth.classList.add('hide');
            }
        }

        if (plans.prepay) {
            if (plans.prepay["3"]) {
                var boxPrice = (plans.prepay["3"].variants.regular.price / 3).toFixed(2);
                threeMonth.classList.remove('hide');
                threeMonth.getElementsByClassName('price')[0].innerHTML = currencySymbol + boxPrice;
            } else {
                if (plans.monthly) {
                    threeMonth.classList.add('disabled');
                } else {
                    threeMonth.classList.add('hide');
                }
            }
            if (plans.prepay["6"]) {
                var boxPrice = (plans.prepay["6"].variants.regular.price / 6).toFixed(2);
                sixMonth.classList.remove('hide');
                sixMonth.getElementsByClassName('price')[0].innerHTML = currencySymbol + boxPrice;
            } else {
                sixMonth.classList.add('hide');
            }
            if (plans.prepay["12"]) {
                var boxPrice = (plans.prepay["12"].variants.regular.price / 12).toFixed(2);
                twelveMonth.classList.remove('hide');
                twelveMonth.getElementsByClassName('price')[0].innerHTML = currencySymbol + boxPrice;
            } else {
                twelveMonth.classList.add('hide');
            }
        } else {
            threeMonth.classList.add('hide');
            sixMonth.classList.add('hide');
            twelveMonth.classList.add('hide');
        }

        oneMonthGiftPrice.innerText = '$' + (this.orderVars.boxData.standard.monthly ? this.orderVars.boxData.standard.monthly.variants.regular.price.toFixed(2) : this.orderVars.boxData.premium.monthly ? this.orderVars.boxData.premium.monthly.variants.regular.price.toFixed(2) : this.orderVars.boxData.deluxe.monthly ? this.orderVars.boxData.deluxe.monthly.variants.regular.price.toFixed(2) : this.orderVars.boxData.motherload.monthly.variants.regular.price.toFixed(2));
        threeMonthGiftPrice.innerText = '$' + (this.orderVars.boxData.standard.prepay["3"] ? (this.orderVars.boxData.standard.prepay["3"].variants.regular.price / 3).toFixed(2) : this.orderVars.boxData.premium.prepay["3"] ? (this.orderVars.boxData.premium.prepay["3"].variants.regular.price / 3).toFixed(2) : this.orderVars.boxData.deluxe.prepay["3"] ? (this.orderVars.boxData.deluxe.prepay["3"].variants.regular.price / 3).toFixed(2) : (this.orderVars.boxData.motherload.prepay["3"].price / 3).toFixed(2));
        sixMonthGiftPrice.innerText = '$' + (this.orderVars.boxData.standard.prepay["6"] ? (this.orderVars.boxData.standard.prepay["6"].variants.regular.price / 6).toFixed(2) : this.orderVars.boxData.premium.prepay["6"] ? (this.orderVars.boxData.premium.prepay["6"].variants.regular.price / 6).toFixed(2) : this.orderVars.boxData.deluxe.prepay["6"] ? (this.orderVars.boxData.deluxe.prepay["6"].variants.regular.price / 6).toFixed(2) : (this.orderVars.boxData.motherload.prepay["6"].price / 6).toFixed(2));
        twelveMonthGiftPrice.innerText = '$' + (this.orderVars.boxData.standard.prepay["12"] ? (this.orderVars.boxData.standard.prepay["12"].variants.regular.price / 12).toFixed(2) : this.orderVars.boxData.premium.prepay["12"] ? (this.orderVars.boxData.premium.prepay["12"].variants.regular / 12).price.toFixed(2) : this.orderVars.boxData.deluxe.prepay["12"] ? (this.orderVars.boxData.deluxe.prepay["12"].variants.regular.price / 12).toFixed(2) : (this.orderVars.boxData.motherload.prepay["12"].price / 12).toFixed(2));
    },
    addToCart: function (items, gift, finish = function () { }) {
        var data = {
            items: []
        };

        items.forEach((item) => {
            if (item.type === "munch" || item.type === "korea") {
                var props = {};
                if (item.prepay) {
                    // props['shipping_interval_frequency'] = 1;
                    // props['shipping_interval_unit_type'] = 'Months';
                    // props['charge_interval_frequency'] = parseInt(item.frequency);
                    // props['charge_interval_unit_type'] = 'Months';
                    // props['charge_on_day_of_month'] = 3;
                    if (gift) {
                        props['Gift Subscription'] = "You are only billed ONCE for all gift subscriptions.";
                    }
                    var prod = {
                        quantity: item.quantity,
                        id: item.variantId,
                        properties: props
                    }
                    if (item.selling_plan) {
                        prod.selling_plan = item.selling_plan;
                    }
                    data.items.push(prod);

                } else {
                    if (!gift) {
                        // props['shipping_interval_frequency'] = 1;
                        // props['shipping_interval_unit_type'] = 'Months';
                        // props['charge_on_day_of_month'] = 3;
                    }
                    var prod = {
                        "quantity": item.quantity,
                        "id": item.variantId,
                        "properties": props
                    }
                    if (item.selling_plan && !gift) {
                        prod.selling_plan = item.selling_plan;
                    }
                    data.items.push(prod);
                }
            } else {
                data.items.push({
                    "quantity": item.quantity,
                    "id": item.variantId,
                    "type": "addon"
                });
            }
        });

        try {
            dataLayer.push({
                'event': 'boxCreatedBox',
                'label': 'box: ' + $wizard_.orderVars.box,
                'box': $wizard_.orderVars.box
            });

            dataLayer.push({
                'event': 'boxCreatedBoxType',
                'label': 'boxType: ' + $wizard_.orderVars.gift ? 'gift' : 'self',
                'boxType': $wizard_.orderVars.gift ? 'gift' : 'self'
            });

            dataLayer.push({
                'event': 'boxCreatedPlan',
                'label': 'plan: ' + $wizard_.orderVars.plan,
                'plan': $wizard_.orderVars.plan
            });

            dataLayer.push({
                'event': 'boxCreatedSize',
                'label': 'size: ' + $wizard_.orderVars.size,
                'size': $wizard_.orderVars.size
            });

            if ($wizard_.orderVars.drink) {
                dataLayer.push({
                    'event': 'boxCreatedDrink',
                    'label': 'drink',
                    'drink': 'true'
                });
            }

            if ($wizard_.orderVars.pp) {
                dataLayer.push({
                    'event': 'boxCreatedPp',
                    'label': 'pp',
                    'pp': 'true'
                });
            }

            if ($wizard_.orderVars.addons.length > 0) {
                for (let addon of $wizard_.orderVars.addons) {
                    dataLayer.push({
                        'event': 'boxCreatedAddon',
                        'label': 'addon: ' + addon,
                        'addons': addon
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }

        if(window.Tapcart.isInitialized){
            try {
                var tapCartItems = [];
                data.items.forEach((item) => {
                    var prodToAdd = {
                        variantId: item.id + '',
                        quantity: item.quantity,
                        attributes: [],
                    };
                    if(item.properties) {
                        for (const [key, value] of Object.entries(item.properties)) {
                            var finalKey = key + '';
                            prodToAdd.attributes.push({
                                key: finalKey,
                                value: value
                            });
                        }
                    }

                    if (item.selling_plan) {
                        prodToAdd.sellingPlanId = item.selling_plan + '';
                    }
                    tapCartItems.push(prodToAdd);
                });
                Tapcart.actions.showToast({
                    message: 'Added to cart',
                    type: 'success', // "success" || "error"
                });
                window.Tapcart.actions.addToCart({
                    lineItems: tapCartItems
                });
                document.getElementsByClassName('wizard-container')[0].classList.add('hide');
                document.getElementById('WizardCompletedScreen').classList.remove('hide');
            } catch (error) {
                Tapcart.actions.showToast({
                    message: error,
                    type: 'error', // "success" || "error"
                })
            }
            
        } else {
            /*if(!window.wizardDirect) {
                Rebuy.SmartCart.skip_open = true;
            }*/
            httpPostAsync('/cart/add.js', data, (result) => {
                /*if(!window.wizardDirect) {
                    //window.location = '/?viewcart=true';
                    window.location.href = '/checkout';
                }*/
                document.getElementById("formWizard").innerHTML = `<div class="final-spinner"><div class="lds-dual-ring"></div></div>`;
                finish('success');
            }, (e) => {
                console.log(e);
                finish(e);
            });
        }        
    },
    getUpsellsAsync: function (sortBy, page, finish = function () { }){
        var upsellUrl = "/collections/munch-upsell";
        if (window.upsellUrl) {
            upsellUrl = window.upsellUrl;
        }
        httpGetAsync(upsellUrl + '?view=json&page=' + page + '&sort_by=' + sortBy, (result) => {
            finish(JSON.parse(result));
        }, (e) => {
            console.log(e);
            finish(e);
        });
    },
    getUpsells: function() {
        if ($wizard_.upsellVars.page === 1) {
            document.getElementById('AddonGrid').innerHTML = "";
            document.getElementById('AddonModals').innerHTML = "";
            document.getElementById('AddonSpinner').classList.remove('hide');
            document.getElementById('AddonLoadMoreBtn').classList.add("hide");
        }
        $wizard_.upsellVars.loading = true;
        $wizard_.getUpsellsAsync($wizard_.upsellVars.sortBy, $wizard_.upsellVars.page, function(data) {
            if (data) {
                if (data.pages >= $wizard_.upsellVars.page) {
                    document.getElementById('AddonLoadMoreBtn').classList.remove("hide");
                    $wizard_.upsellVars.page++;
                    if (data.pages < $wizard_.upsellVars.page) {
                        document.getElementById('AddonLoadMoreBtn').classList.add("hide");
                    }
                }
                document.getElementById('AddonSpinner').classList.add('hide');
                data.products.forEach(function(product, index, prods) {
                    var upsellBtnClass = $wizard_.orderVars.addons.includes(product.variants[0].id.toString()) ? 'selected': '';
                    var upsellBtnText = $wizard_.orderVars.addons.includes(product.variants[0].id.toString()) ? 'Remove': 'Add';
                    var inventoryCount = 0;
                    if (product.variants && product.variants.length > 0 && product.variants[0].inventory_quantity) {
                        inventoryCount = product.variants[0].inventory_quantity;
                    }
                    var upsellTemplate = 
                        `<div class="grid__item">
                            <div class="add-on">
                            <div class="add-on-img">
                                <div class="add-on-imgwrapper">
                                <img data-label="Add On - ${ product.id }" class="modal-open" data-id="${ product.id }-modal" srcset="${ product.image } 4x,
                                ${ product.image } 3x,
                                ${ product.image } 2x,
                                ${ product.image } 1x" src="${ product.image }" loading="lazy" alt="Munch Addict Snack Box Bottom">
                                </div>
                            </div>

                            <div class="add-on-panel">
                                <span data-label="Add On - ${ product.title }" class="add-on-title modal-open" data-id="${ product.id }-modal">${ product.title }</span>
                                <div class="add-on-buy">
                                <div>
                                    <span class="add-on-price ${ product.compare_price ? "on-sale" : "" }">${ product.price }</span>
                                    <span class="compare-price"><s>${ product.compare_price ? product.compare_price : "" }</s></span>
                                </div>
                                <span class="low-stock-warning">${ inventoryCount < 10 && inventoryCount > 0 ? "Only " + inventoryCount + " left!" : ""}</span>
                                <div class="add-on-select">
                                    <!-- <input data-value="${ product.variants[0].id }" type="number"
                                    value="1" class="qty" /> -->
                                    <button data-title="${ product.title }" data-value="${ product.variants[0].id }" class="button add-bundle-btn ${ upsellBtnClass }">${ upsellBtnText }</button>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>`;
                        document.getElementById('AddonGrid').innerHTML += upsellTemplate;

                        var upsellModalTemplate = 
                            `<div id="${ product.id }-modal" class="modal modal-scroll modal-info box-modal" role="dialog" tabindex="-1">
                            <div class="model-inner">
                              <div class="modal-header">
                                <h3>${ product.title }</h3>
                                <button class="modal-close" data-id="demo-modal" aria-label="Close">&times;</button>
                              </div>
                              <div class="modal-description grid--1-col">
                                <div class="product__media-wrapper">
                                  <slider-component class="slider-mobile-gutter">
                                    <a class="skip-to-content-link button visually-hidden" href="#ProductInfo-template--15684542267548__get_started_wizard">
                                    Skip to product information
                                    </a>
                                    <ul class="product__media-list grid grid--peek list-unstyled slider slider--mobile" role="list">
                                      
                                        <li class="product__media-item grid__item slider__slide">
                                        <img data-label="Add On - ${ product.id }" class="modal-open" data-id="${ product.id }-modal" srcset="${ product.image_large } 4x,
                                        ${ product.image_large } 3x,
                                        ${ product.image_large } 2x,
                                        ${ product.image_large } 1x" src="${ product.image_large }" loading="lazy" alt="Munch Addict Snack Box Bottom">
                                        </li>
                                    </ul>
                                    <div class="slider-buttons slider-buttons--overlay no-js-hidden small-hide">
                                      <div class="slider-counter caption">
                                        <span class="slider-counter--current">1</span>
                                        <span aria-hidden="true">
                                          /
                                        </span>
                                        <span class="visually-hidden">of</span>
                                        <span class="slider-counter--total">1</span>
                                      </div>
                                      <button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                    </path></svg></button>
                                      <button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                    </path></svg></button>
                                    </div>
                                  </slider-component>
                                </div>
                                <p class="margin-top">${ product.description }</p>
                                <div class="step-panel wzd-buttons modal-btn-panel">
                                  <button class="button button--secondary full-width select-btn modal-close-btn" data-id="demo-modal" aria-label="Close">
                                    <span class="modal-close-btn">Close</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>`;
                          document.getElementById('AddonModals').innerHTML += upsellModalTemplate;
                })
                
            }
            $wizard_.upsellVars.loading = false;
            document.getElementById('AddonLoadMoreBtn').innerHTML = "<span>Load More</span>";
        });
        

    }
};

//Initialize Wizard and Form Events
function initWizard() {
    const orderForm = document.getElementById('formWizard');
    if (orderForm) {
        delegate(document, "click", ".radio-group", function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            if (targetElement.classList.contains('button-left') || targetElement.classList.contains('button-right') || targetElement.classList.contains('extra-box-info')) {
                if (targetElement.classList.contains('extra-box-info')) {
                    targetElement = targetElement.parentElement.parentElement;
                } else {
                    targetElement = targetElement.parentElement;
                }

            }

            if (targetElement.classList.contains('grid-button')) {
                targetElement = targetElement.parentElement;
            }

            if (targetElement.classList.contains('disabled') || targetElement.parentElement.classList.contains('disabled')) {
                return;
            }
            clearButtons(targetElement.parentElement.id);
            targetElement.classList.add('selected');

            $wizard_.radioBtnClick(targetElement);
        });

        delegate(document, "click", ".select-btn", function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            if (targetElement.nodeName.toLowerCase() === 'span') {
                targetElement = targetElement.parentElement;
            }
            $wizard_.primaryBtnClick(targetElement);
        });

        delegate(document, "click", ".cart-btn", function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            if (targetElement.nodeName.toLowerCase() === 'span') {
                targetElement = targetElement.parentElement;
            }
            if (!$wizard_.orderVars.adding) {
                $wizard_.orderVars.adding = true;
                targetElement.innerHTML = "<span>Adding...</span>";
                var pp = $wizard_.orderVars.pp ? 'priority_processing' : 'regular';
                var items = [];
                var prepay = $wizard_.orderVars.plan === 1 ? false : true;
                items.push({
                    quantity: 1,
                    variantId: prepay ? $wizard_.orderVars.boxData[$wizard_.orderVars.size].prepay[$wizard_.orderVars.plan].variants[pp].id : $wizard_.orderVars.boxData[$wizard_.orderVars.size].monthly.variants[pp].id,
                    type: $wizard_.orderVars.box,
                    frequency: $wizard_.orderVars.plan,
                    prepay: prepay,
                    selling_plan: prepay ? $wizard_.orderVars.boxData[$wizard_.orderVars.size].prepay[$wizard_.orderVars.plan].variants[pp].selling_plan : $wizard_.orderVars.boxData[$wizard_.orderVars.size].monthly.variants[pp].selling_plan,
                    drink: false
                });
                if ($wizard_.orderVars.drink) {
                    var drinkObj = $wizard_.orderVars.gift ? drinkGiftItems : drinkItems;
                    items.push({
                        quantity: 1,
                        variantId: prepay ? drinkObj[$wizard_.orderVars.plan].id : drinkObj["1"].id,
                        type: $wizard_.orderVars.box,
                        frequency: $wizard_.orderVars.plan,
                        prepay: prepay,
                        selling_plan: prepay ? drinkObj[$wizard_.orderVars.plan].selling_plan : drinkObj["1"].selling_plan,
                        drink: $wizard_.orderVars.drink
                    });
                }

                if ($wizard_.orderVars.plan > 1) {
                    var itemGift = {
                        quantity: 1,
                        variantId: $wizard_.orderVars.freeGift,
                        drink: false
                    };
                    console.log("adding itemGift" + JSON.stringify(itemGift));
                    items.push(itemGift);
                }

                $wizard_.orderVars.addons.forEach((addon) => {
                    items.push({
                        quantity: 1,
                        variantId: addon,
                        drink: false
                    })
                });
                
                $wizard_.addToCart(items, $wizard_.orderVars.gift, function (e) {
                    if (e !== 'success' && e) {
                        $wizard_.orderVars.adding = false;
                        targetElement.innerHTML = "<span>Continue to Your Cart</span>";
                        var extraErrorText = '';
                        if (e.status === 422) {
                            extraErrorText = ' Please remove item from your cart'
                        }
                        document.getElementById('Error_Text').innerText = e.description ? e.description + extraErrorText : 'Unknown Error';
                        modal = document.getElementById('error-info-modal');
                        openModal(document.getElementById('error-info-modal'));
                    }
                });
            }
        });

        delegate(document, "click", ".add-bundle-btn", function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            const addon = $wizard_.orderVars.addons.indexOf(targetElement.dataset.value);
            if (addon > -1) {
                $wizard_.orderVars.addons.splice($wizard_.orderVars.addons.indexOf(addon), 1);
                targetElement.classList.remove('selected');
                targetElement.innerHTML = "Add";
            } else {
                targetElement.innerHTML = "Remove";
                targetElement.classList.add('selected');
                $wizard_.orderVars.addons.push(targetElement.dataset.value);

                try {
                    if ($wizard_.analytics.addons.indexOf(targetElement.dataset.value) < 0) {
                        dataLayer.push({ 'event': 'selectAddon', 'label': targetElement.dataset.title ? targetElement.dataset.title : '' });
                        $wizard_.analytics.addons.push(targetElement.dataset.value);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        });

        delegate(document, "click", "#AddonLoadMoreBtn", function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            if (targetElement.nodeName.toLowerCase() === 'span') {
                targetElement = targetElement.parentElement;
            }
            if (!$wizard_.upsellVars.loading) {
                targetElement.innerHTML = "<span>Loading...</span>";
                $wizard_.getUpsells();
            }
        });

        delegate(document, "click", ".upsell-sort-btn", function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            if (!$wizard_.upsellVars.loading) {
                $wizard_.upsellVars.page = 1;
                $wizard_.upsellVars.sortBy = targetElement.dataset.value;

                var dropdowns = document.getElementsByClassName('addon-sort-selected');
                for (var x = 0; x < dropdowns.length; x++) {
                    dropdowns[x].innerHTML = targetElement.innerHTML;
                }
                window.scrollTo(0,0);
                $wizard_.getUpsells();
            }
        });      

        

        $wizard_.refresh('init');
        $wizard_.getUpsells();
    }
}

initWizard();